import {SEARCH_NAV_HEIGHT} from '@wandb/weave/common/css/globals.styles';
import React, {memo, type ReactElement} from 'react';

import * as S from './PageWithSidebar.styles';

type PageWithSidebarProps = {
  sidebar: ReactElement;
  children: ReactElement;
  /** Constrain the sidebar to viewport height and scroll its content independently. */
  sidebarScrollable?: boolean;
  sidebarStyle?: Record<string, string>;
  contentStyle?: Record<string, string>;
};

const sidebarScrollableStyle = {
  maxHeight: `calc(100vh - ${SEARCH_NAV_HEIGHT})`,
  overflowY: 'auto' as const,
};

const PageWithSidebarComp = ({
  sidebar,
  children,
  sidebarScrollable,
  sidebarStyle,
  contentStyle,
}: PageWithSidebarProps) => {
  return (
    <S.PageWithSidebar>
      <S.InlineSidebar
        style={{
          ...(sidebarScrollable && sidebarScrollableStyle),
          ...sidebarStyle,
        }}>
        {sidebar}
      </S.InlineSidebar>
      <S.Content style={contentStyle}>{children}</S.Content>
    </S.PageWithSidebar>
  );
};

export const PageWithSidebar = memo(PageWithSidebarComp);
